import { deliveryClient } from '../../../lib/connect/clients';
import { makeEntityHooks } from '../_shared/hooks/makeEntityHooks';
// Sectors — { id, companyId, name }
export const sectorHooks = makeEntityHooks({
    key: 'sector',
    list: async (req)=>{
        const resp = await deliveryClient.listSectors(req);
        return {
            items: resp.sectors
        };
    },
    upsert: async (req)=>{
        const resp = await deliveryClient.upsertSector(req);
        return resp.sector;
    },
    remove: async (id)=>{
        await deliveryClient.deleteSector({
            id
        });
    },
    entityId: (s)=>s.id
});
// Business Units — { id, companyId, sectorId, name, managerName }
export const businessUnitHooks = makeEntityHooks({
    key: 'business unit',
    list: async (req)=>{
        const resp = await deliveryClient.listBusinessUnits({
            companyId: req.companyId,
            sectorId: req.sectorId ?? ''
        });
        return {
            items: resp.businessUnits
        };
    },
    upsert: async (req)=>{
        const resp = await deliveryClient.upsertBusinessUnit(req);
        return resp.businessUnit;
    },
    remove: async (id)=>{
        await deliveryClient.deleteBusinessUnit({
            id
        });
    },
    entityId: (b)=>b.id
});
// Portfolios — { id, companyId, businessUnitId, name, directorName, directorRole }
export const portfolioHooks = makeEntityHooks({
    key: 'portfolio',
    list: async (req)=>{
        const resp = await deliveryClient.listPortfolios({
            companyId: req.companyId,
            businessUnitId: req.businessUnitId ?? ''
        });
        return {
            items: resp.portfolios
        };
    },
    upsert: async (req)=>{
        const resp = await deliveryClient.upsertPortfolio(req);
        return resp.portfolio;
    },
    remove: async (id)=>{
        await deliveryClient.deletePortfolio({
            id
        });
    },
    entityId: (p)=>p.id
});
